export const CREATIVE_JOB_STATUS = {
  PENDING: "pending",
  PROCESSING: "processing",
  SUCCESS: "success",
  ERROR: "error",
  CANCELLED: "cancelled",
};

export const CREATIVE_JOB_IN_PROGRESS_STATUSES = new Set([
  CREATIVE_JOB_STATUS.PENDING,
  CREATIVE_JOB_STATUS.PROCESSING,
]);

export const CREATIVE_JOB_TERMINAL_STATUSES = new Set([
  CREATIVE_JOB_STATUS.SUCCESS,
  CREATIVE_JOB_STATUS.ERROR,
]);
